import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import CandidateClaimForm from "./CandidateClaimForm";

const CandidateOwnershipModal = ({
  candidate,
  existingClaim,
  isOpen,
  onClose,
  onSuccess,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-950/55 p-4 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, y: 24, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.96 }}
            transition={{ duration: 0.22, ease: "easeOut" }}
            className="max-h-[92vh] w-full max-w-3xl overflow-y-auto rounded-[2rem] border border-white/60 bg-white p-6 shadow-2xl shadow-slate-900/20 sm:p-8"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="mb-6 flex items-start justify-between gap-4">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-400">
                  Candidate Ownership
                </p>
                <h2 className="mt-2 text-2xl font-black tracking-tight text-slate-900">
                  Claim {candidate?.name || "Candidate"} Profile
                </h2>
                <p className="mt-2 text-sm text-slate-600">
                  Submit your verification request and the admin team will review your supporting details.
                </p>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-500 transition hover:bg-slate-200"
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            <CandidateClaimForm
              candidate={candidate}
              existingClaim={existingClaim}
              onCancel={onClose}
              onSuccess={(claim) => {
                onSuccess?.(claim);
                onClose?.();
              }}
              submitLabel="Submit Ownership Claim"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CandidateOwnershipModal;
